import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import "./eventDetail.css";
import { useLocation } from "react-router-dom";

export default function EventDetailView({ item, handleCalendarMove, defaultLanguage = "ko" }) {
  const [events, setEvents] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ArticleID = queryParams.get("ArticleID"); // 'siteNo' 쿼리 파라미터의 값을 가져옵니다.

  const fetchBoardData = async () => {

    await fetch(`https://b2capi.tripbox.co.kr/Site/GetArticle?ArticleID=${ArticleID}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {

        setEvents(data); // 변경된 데이터로 상태 업데이트

        // console.log(data)

        // setEvents(
        //   data.map((item) => {
        //     return {
        //       title: item.Title,
        //       start: item.start,
        //       end: item.end,
        //       BoardID: item.BoardID,
        //       articleID: item.ArticleID,
        //       WriterName: item.WriterName,
        //       ContentHtml: item.ContentHtml,
        //     };
        //   }) // 데이터 변환
        // ); // 변경된 데이터로 상태 업데이트

        window.dispatchEvent(new Event("resize"));
      })
      .catch((error) => {
        console.error("Fetching data failed:", error);
        setEvents([]);
      });
  };

  useEffect(() => {
    const initializeBoardData = async () => {
      await fetchBoardData();
    };

    initializeBoardData();
  }, [ArticleID]);

  console.log(events)

  return (
    <>
      <div className="  mx-auto p-4 md:p-8 overflow-auto ">
        <div className="post  ">
          <div className="flex flex-wrap break-word  text-3xl md:text-2xl font-bold mb-4 "> {` ${defaultLanguage === "ko" ? "게시판" : "Board"}`}</div>

          <hr className="h-px mx-0 my-4   border-0  bg-gradient-to-r from-transparent via-black/100 to-transparent" />
          <div className=" break-all text-lg md:text-xl font-bold mb-4">{events.title || ""}</div>
          <span className="text-sm md:text-base text-gray-600"> {` ${defaultLanguage === "ko" ? "작성자 : " : "WriterName : "}${events?.WriterName}`}</span>
          <hr className="h-px mx-0 my-4   border-0  bg-gradient-to-r from-transparent via-black/100 to-transparent" />
          {/* <pre className="text-sm md:text-lg  break-all scale-70 md:scale-100 ">{parse(item?.ContentHtml || "")}</pre> */}
          {/* <div className=" text-sm md:text-lg  whitespace-pre-wrap  ">{parse(events?.ContentHtml || "")}</div> */}
          <div className=" text-sm md:text-lg  parsed-content  ">{parse(events?.ContentHtml || "")}</div>


          {/* <hr className="h-px mx-0 my-4   border-0  bg-gradient-to-r from-transparent via-black/100 to-transparent" /> */}

          {/* <div className="flex justify-center">
            <button
              className="bg-black py-3 px-10 text-white  font-semibold"
              onClick={() => {
                handleCalendarMove();
              }}
            >
              {` ${defaultLanguage === "ko" ? "목록보기" : "List view"}`}
            </button>
          </div> */}
        </div>
      </div>
    </>
  );
}
